<i18n src="./resources/locales.json" />

<template>
  <section v-intersect="onIntersect" class="interaction-crm-contact-template-selection">
    <div class="header">
      <v-combobox
        hide-details
        dense
        class="bp-selection"
        :items="businessProcesses"
        :label="$t('templateSelection.businessProcess')"
        :menu-props="{ bottom: true }"
        :value="selectedBusinessProcess"
        @click.stop
        @change="onBusinessProcessChange"
      />
    </div>

    <InteractionCrmContactSettings
      v-if="selectedBusinessProcess"
      :contact-id="contactId"
      :business-process-id="selectedBusinessProcess.value"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import InteractionCrmContactSettings from '@/components/ecs-interaction/InteractionCrmContactSettings.vue';

export default {
  name: 'InteractionCrmContactTemplateSelection',

  components: {
    InteractionCrmContactSettings
  },

  props: {
    contactId: {
      type: String,
      required: true
    },
    businessProcessId: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      selectedBusinessProcess: null
    };
  },

  computed: {
    ...mapGetters('BUSINESS_PROCESSES', ['availableBusinessProcesses']),

    businessProcesses() {
      return this.availableBusinessProcesses.map(bp => {
        return { text: bp.name, value: bp.id };
      });
    }
  },

  methods: {
    onIntersect(entries) {
      if (entries[0].isIntersecting) {
        this.selectedBusinessProcess = this.businessProcesses.find(bp => bp.value === this.businessProcessId);
      }
    },

    onBusinessProcessChange(event) {
      this.selectedBusinessProcess = event;
    }
  }
};
</script>

<style scoped>
.interaction-crm-contact-template-selection {
  .header {
    border-top: 1px solid var(--v-border-color);
    border-bottom: 1px solid var(--v-border-color);
    padding: 20px 20px 16px;
    background-color: var(--v-surface-lighten1);
  }
}
</style>
